import { render, staticRenderFns } from "./modal-change-code.vue?vue&type=template&id=bef78076&scoped=true"
import script from "./modal-change-code.vue?vue&type=script&lang=js"
export * from "./modal-change-code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef78076",
  null
  
)

export default component.exports